export class Helper {
  constructor() {
    this.events = {
      currentScreen: Helper.screenSize,
      screenChange: new CustomEvent( 'screenChange', {
        detail: {
          to: Helper.screenSize
        }
      })
    };
    Helper.widthListener(() => this._fireScreenEvents());
    document.dispatchEvent( this.events.screenChange );
  }

  // IE fix for tab navigation as addAttributesToSVGElement not working
  // https://github.com/mrsum/webpack-svgstore-plugin/issues/148
  // https://jira.pixelpark.com/jira/browse/MWIDENRW-567
  static addAttributesToSVGContainer() {
    // Fractal DOM
    document.querySelectorAll( 'body > svg' ).forEach( el => {
      el.setAttribute( 'focusable', 'false' );
      el.setAttribute( 'aria-hidden', 'true' );
    });
    // Drupal DOM
    document.querySelectorAll( '.dialog-off-canvas-main-canvas > svg' ).forEach( el => {
      el.setAttribute( 'focusable', 'false' );
      el.setAttribute( 'aria-hidden', 'true' );
    });
  }

  static instantiateModule( module ) {
    document.querySelectorAll( module.selector ).forEach( el => new module.moduleClass( el ));
  }

  static insertAfter( newNode, referenceNode ) {
    referenceNode.parentNode.insertBefore( newNode, referenceNode.nextSibling );
  }

  static get topOffset() {
    return document.documentElement.scrollTop || document.body.scrollTop;
  }

  static scrollListener( callback ) {
    window.addEventListener( 'scroll', () => {
      callback && callback();
    });
  }

  // TODO add siteStaus to event details
  static widthListener( callback ) {
    window.addEventListener( 'resize', e => {
      callback && callback( e );
    });
  }


  static headerChangeListener( callback ) {
    document.addEventListener( 'headerChange', e => {
      callback && callback( e );
    });
  }

  static screenChangeListener( callback ) {
    document.addEventListener( 'screenChange', e => {
      callback && callback( e );
    });
  }

  _fireScreenEvents() {
    if ( this.events.currentScreen !== Helper.screenSize ) {
      this.events.screenChange.detail.to = Helper.screenSize;
      this.events.currentScreen = Helper.screenSize;
      document.dispatchEvent( this.events.screenChange );
    }
  }

  static debounce( func, wait, scope ) {
    let timeout;
    return function() {
      let context = scope || this,
        args = arguments;
      let later = function() {
        timeout = null;
        func.apply( context, args );
      };
      clearTimeout( timeout );
      timeout = setTimeout( later, wait );
    };
  }

  static throttle( func, limit ) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if ( !inThrottle ) {
        func.apply( context, args );
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit );
      }
    };
  }

  // TODO: Device Spcific
  static get screenSize() {
    const mqDesktop = window.matchMedia( '(min-width: 1024px)' ).matches,
      mqTablet = window.matchMedia( '(min-width: 768px)' ).matches,
      mqMobile = window.matchMedia( '(min-width: 320px)' ).matches;

    if ( mqDesktop ) {
      return 'desktop';
    } else if ( mqTablet ) {
      return 'tablet';
    } else {
      return 'mobile';
    }
  }

  static getClosest( elem, selector ) {
    // Element.matches() polyfill
    if ( !Element.prototype.matches ) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function( s ) {
          let matches = ( this.document || this.ownerDocument ).querySelectorAll( s ),
            i = matches.length;
          while ( --i >= 0 && matches.item( i ) !== this ) {
            // empty
          }
          return i > -1;
        };
    }

    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector )) {
        return elem;
      }
    }
    return null;
  }

  static scrollTo( domNode, options ) {

    var defaultOptions = {
      'smooth': true,
      'seconds': 0.2,
      'marginTop': 20
    };

    Object.assign( defaultOptions, options );

    let element = domNode,
      currentScrollPosition = window.scrollY,
      finalScrollPosition = Helper.getCoords( element ).top - defaultOptions.marginTop,
      scrollDown = finalScrollPosition > window.scrollY,
      duration = defaultOptions.seconds,
      fps = 60,
      animationFrames = fps * duration,
      step = Math.abs( Math.ceil(( finalScrollPosition - currentScrollPosition ) / animationFrames )),
      scroll = () => {
        window.scrollTo( 0, Math.max( 0, currentScrollPosition ));
        if ( defaultOptions.smooth ) {
          if ( scrollDown && currentScrollPosition < finalScrollPosition && step > 0 ) {
            currentScrollPosition += step;
            window.requestAnimationFrame( scroll );
          } else if ( !scrollDown && currentScrollPosition > finalScrollPosition && step > 0 ) {
            currentScrollPosition -= step;
            window.requestAnimationFrame( scroll );
          }
        }
      };

    if ( element && step > 0 ) {
      if ( !defaultOptions.smooth ) {
        currentScrollPosition = finalScrollPosition;
      } else {
        if ( scrollDown ) {
          currentScrollPosition += step;
        } else {
          currentScrollPosition -= step;
        }
      }
      scroll();
    }
  }

  // http://stackoverflow.com/a/26230989
  static getCoords( elem ) {
    let box = elem.getBoundingClientRect(),
      body = document.body,
      docEl = document.documentElement,
      scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
      scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
      clientTop = docEl.clientTop || body.clientTop || 0,
      clientLeft = docEl.clientLeft || body.clientLeft || 0,
      top = box.top + scrollTop - clientTop,
      left = box.left + scrollLeft - clientLeft;
    return { top: Math.round( top ), left: Math.round( left ) };
  }

  // https://stackoverflow.com/a/9039885
  static checkForIosDevice() {
    return /iPad|iPhone|iPod/.test( navigator.userAgent ) && !window.MSStream;
  }
}
